import React from "react";
import { Helmet } from "react-helmet-async";

type SeoWrapperProps = {
  title: string;
  description?: string;
  canonical?: string;
  image?: string;
  type?: "website" | "article";
  noindex?: boolean;
  children?: React.ReactNode;
};

export const SeoWrapper: React.FC<SeoWrapperProps> = ({
  title,
  description,
  canonical,
  image,
  type = "website",
  noindex = false,
  children,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:type" content={type} />
      {image ? <meta property="og:image" content={image} /> : null}

      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}

      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      {children}
    </Helmet>
  );
};
